import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { AccordionContext, Card, useAccordionToggle } from 'react-bootstrap'
import cn from 'classnames'

export default function CustomToggle({ children, eventKey, onClick }) {
  const activeKey = useContext(AccordionContext)
  const decoratedOnClick = useAccordionToggle(eventKey, () => {
    if (onClick) onClick(eventKey)
  })

  return (
    <Card.Header
      onClick={(e) => {
        decoratedOnClick(e)
      }}
      className={cn({ open: activeKey === '0' })}
    >
      {children}
    </Card.Header>
  )
}

CustomToggle.propTypes = {
  children: PropTypes.node,
  eventKey: PropTypes.string,
  onClick: PropTypes.func,
}
